module.exports = __webpack_public_path__ + "img/57.7760e531.jpg";